import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
function NotFoundBanner() {
  return (

    <div className='common-banner-sec common-flex-center blog-banner'>
      <div className='overlay'></div>
      <Container fluid>
        <Row className='common-flex-center'>
          <Col md={8}>
            <div className=' '>
              <h1 className='common-head whiteColor'>404 PAGE</h1>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NotFoundBanner;


